import React from 'react';

import RenderContent from 'app/components/layout/RenderContent';

import ListPayments from './components/ListPayments';
import ListPaymentsAllTeams from './components/ListPaymentsAllTeams';

interface IListPaymentsLayoutProps {
  match: any;
}
export default class ListPaymentsLayout extends React.Component<
  IListPaymentsLayoutProps,
  {}
> {
  static defaultProps: IListPaymentsLayoutProps = {
    match: undefined,
  };

  render() {
    return (
      <RenderContent
        className="my-dashboard-app"
        match={this.props.match}
      >
        <ListPaymentsAllTeams />
      </RenderContent>
    );
  }
}
